import React, { Component } from 'react';
import { Button, Modal, Form, Grid} from 'semantic-ui-react';
import * as api from '../../api';
import { toast } from 'react-toastify';

class AddReleaseModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            releaseVersion: '',
            features: [''],
        };
    }

    setOpen = (open) => {
        this.setState({ modalOpen: open });
    }

    handleVersionChange = (e, { value }) => {
        this.setState({ releaseVersion: value });
    }

    handleFeatureChange = (index) => (e, { value }) => {
        let newFeatures = [...this.state.features];
        newFeatures[index] = value;
        this.setState({ features: newFeatures });
    }

    handleAddFeature = () => {
        this.setState((prevState) => ({ features: [...prevState.features, ''] }));
    }

    handleRemoveFeature = (index) => {
        this.setState((prevState) => ({ features: prevState.features.filter((feature, i) => i !== index) }));
    }

    handleSubmit = () => {
        
      // Check if release version or any feature is empty
    if(this.state.releaseVersion.trim() === '' || this.state.features.some(feature => feature.trim() === '')) {
        toast.error("Version number or feature can't be blank", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false
        });
        return;
    }

        const formData = new FormData();
        formData.append("Version", this.state.releaseVersion);
        formData.append("Features", JSON.stringify(this.state.features));

        api.addRelease(formData)
            .then(verifyRes => {
                if (verifyRes.success) {
                    this.setState({
                        modalOpen: false,
                        releaseVersion: '',
                        features: [''],
                    });
                    toast.success("Release successfully created. Your reference is : " + verifyRes.id, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: false,
                        closeOnClick: false
                    });

                    this.props.onNewRelease();
                } else {
                    this.setState({
                        modalOpen: false,
                    });
                    toast.error("Error submitting - contact IT Helpdesk", {
                        position: toast.POSITION.TOP_CENTER,
                        delay: 50,
                        autoClose: false
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    modalOpen: false,
                });
                toast.error("Unhandled Error - contact IT Helpdesk", {
                    position: toast.POSITION.TOP_CENTER,
                    delay: 50,
                    autoClose: false
                });
            });
    }

    render() {
        return (
<Grid.Column>
    <Button onClick={() => this.setOpen(true)}>Add Release</Button>
    <Modal
        onClose={() => this.setOpen(false)}
        open={this.state.modalOpen}
        >
        <Modal.Header>Add a new Release</Modal.Header>
        <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
                <Form.Input required label='Release Version' placeholder='Release Version' 
                    onChange={this.handleVersionChange} value={this.state.releaseVersion} />
                {this.state.features.map((feature, index) => (
                    <Grid key={index}>
                        <Grid.Column width={14}>
                            <Form.Input required label='Feature' placeholder='Feature' 
                                onChange={this.handleFeatureChange(index)} value={feature} />
                        </Grid.Column>
                        <Grid.Column width={2} textAlign='center' verticalAlign='middle'>
                            <Button fluid type='button' onClick={() => this.handleRemoveFeature(index)}>Remove</Button>
                        </Grid.Column>
                    </Grid>
                ))}
                <Button type='button' onClick={this.handleAddFeature}>Add Feature</Button>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button type='submit' onClick={this.handleSubmit}>Submit</Button>
            <Button onClick={() => this.setOpen(false)}>Cancel</Button>
        </Modal.Actions>
    </Modal>
</Grid.Column>


        
        );
    }
}

export default AddReleaseModal;
